import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  TopToolbar,
  Button,
  NumberField,
  DateField,
} from "react-admin";
import { Sync } from "@mui/icons-material";
import { useNotify } from "react-admin";
import { useState } from "react";
import { handleApiError } from "../../../utils/errorHandler";
import { ProviderDataProvider } from "../../../dataProviders/providerProvider";
import { ProviderStatusChip } from "./ProviderStatusChip";
import { ProviderTypeChip } from "./ProviderTypeChip";
import { ProviderFilters } from "./ProviderFilters";
import { ProviderDeactivateAction } from "./ProviderDeactivateAction";
import { SetAllMarkupButton } from "./SetAllMarkupButton";

const RateHawkSyncButton = () => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const handleSync = async () => {
    setLoading(true);
    try {
      await ProviderDataProvider.syncRateHawkStaticData();
      notify("RateHawk static data synced successfully", { type: "success" });
    } catch (error) {
      const appError = handleApiError(error);
      notify(appError.message, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      label="Sync RateHawk Data"
      onClick={handleSync}
      disabled={loading}
      startIcon={<Sync />}
    >
      Sync RateHawk Data
    </Button>
  );
};

const ListActions = () => (
  <TopToolbar>
    <SetAllMarkupButton />
    <RateHawkSyncButton />
  </TopToolbar>
);

export const ProviderList = () => (
  <List
    filters={ProviderFilters}
    sort={{ field: "createdAt", order: "DESC" }}
    actions={<ListActions />}
  >
    <Datagrid rowClick="show">
      <TextField source="code" />
      <TextField source="name" />
      <ProviderTypeChip />
      <ProviderStatusChip />
      <NumberField source="priority" />
      <DateField source="createdAt" label="Created" showTime />
      <ShowButton />
      <EditButton />
      <ProviderDeactivateAction />
    </Datagrid>
  </List>
);
